import { TextField } from "@mui/material";
import { RoomContext } from "App/context";
import { useSocket } from "common/hooks/useSocket";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DraftModel, DraftStep } from "types/Draft/type";

type FirstPartBansSelectorType = {};

export const MIN_FIRST_PART_BANS = 2;
export const MAX_FIRST_PART_BANS = 4;

// Nombre de bans par joueur en tête de draft : les étapes "Ban" initiales, alternées P1/P2.
export const countFirstPartBans = (draftModel: DraftModel) => {
  let banCount = 0;
  while (draftModel.steps[banCount]?.action === "Ban") banCount++;
  return banCount / 2;
};

// Remplace les bans de tête par `value` bans par joueur, le reste du modèle est conservé.
export const withFirstPartBans = (
  draftModel: DraftModel,
  value: number,
): DraftModel => {
  const bans: DraftStep[] = [];
  for (let i = 0; i < value; i++) {
    bans.push(
      { player: "Player 1", action: "Ban", quantity: 1 },
      { player: "Player 2", action: "Ban", quantity: 1 },
    );
  }
  return {
    ...draftModel,
    steps: [
      ...bans,
      ...draftModel.steps.slice(countFirstPartBans(draftModel) * 2),
    ],
  };
};

const FirstPartBansSelector = (props: FirstPartBansSelectorType) => {
  const { t } = useTranslation();
  const socket = useSocket();
  const { draftModel, admin } = useContext(RoomContext);

  return (
    <TextField
      disabled={!admin}
      label={t("Bans en 1ère partie")}
      type="number"
      value={countFirstPartBans(draftModel)}
      onChange={(evt) => {
        if (evt.target.value !== undefined) {
          const value = parseInt(evt.target.value);
          if (value >= MIN_FIRST_PART_BANS && value <= MAX_FIRST_PART_BANS) {
            socket.emit(
              "update-draft-model",
              withFirstPartBans(draftModel, value),
            );
          }
        }
      }}
      sx={{ width: "10rem" }}
    />
  );
};

export default FirstPartBansSelector;
